import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { NewVersionConfirmationService } from './new-version-confirmation.service';

@Component({
    selector: 'app-new-version-confirmation-dialog',
    templateUrl: './new-version-confirmation-dialog.html',
    imports: [
        AsyncPipe,
    ],
    styleUrl: './new-version-confirmation-dialog.scss'
})
export class NewVersionConfirmationDialog {
    public args!: { confirm: () => void };

    public newVersionConfirmationService = inject(NewVersionConfirmationService);

    public onCancel(): void {
        this.newVersionConfirmationService.showDialog.next(false);
    }

    public confirm(): void {
        location.replace(location.origin);
        this.onCancel();
    }
}
